import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import QuickCamLogoHeader from '../../assets/svg/quickcam_logo.svg';

export default function PublisherMark(): JSX.Element {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Box
        component="img"
        src={QuickCamLogoHeader}
        alt="QuickCam"
        sx={{ height: 36, width: 'auto', display: 'block' }}
      />
      <Typography
        sx={{
          fontSize: '0.82rem',
          lineHeight: 1.25,
          color: 'var(--qc-shell-muted, #a9b5ca)',
        }}
      >
        QuickLinks by QuickCam
      </Typography>
    </Stack>
  );
}
